import { AllocationViewActionIdentifierModel, AllocationViewDepartureDockModel } from '../../models';

export class AllocationViewReleaseFromDockAction {
  public static readonly type = '[AllocationViewReleaseFromDockAction] Dock Departure';

  constructor(public data: AllocationViewDepartureDockModel) {}
}

export class AllocationViewReleaseFromDockActionPrepare {
  public static readonly type = '[AllocationViewReleaseFromDockAction] Dock Departure Prepare';

  constructor(public identifier: AllocationViewActionIdentifierModel, public language: string) {}
}

export class AllocationViewReleaseFromDockActionSetInitialState {
  public static readonly type = '[AllocationViewReleaseFromDockAction] Set Initial State';
}
